import React, { createContext, useState, useEffect, useContext } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const getInitialTheme = () => {
    const savedTheme = localStorage.getItem('app-theme');
    if (savedTheme) {
      return savedTheme;
    }

    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return 'dark';
    }
    return 'light';
  };

  const [theme, setTheme] = useState(getInitialTheme);

  const switchTheme = (newTheme) => {
    setTheme(newTheme);
    localStorage.setItem('app-theme', newTheme);

    document.documentElement.setAttribute('data-theme', newTheme);
    changePrimeReactTheme(newTheme);
  };

  const changePrimeReactTheme = (themeMode) => {
    const themeLink = document.getElementById('app-theme');
    const version = '@10.9.7';

    const lightTheme = `https://unpkg.com/primereact${version}/resources/themes/lara-light-indigo/theme.css`;
    const darkTheme = `https://unpkg.com/primereact${version}/resources/themes/lara-dark-indigo/theme.css`;

    if (themeLink) {
      themeLink.href = themeMode === 'dark' ? darkTheme : lightTheme;
    }
  };

  const toggleTheme = () => {
    const nextTheme = theme === 'light' ? 'dark' : 'light';
    switchTheme(nextTheme);
  };

  useEffect(() => {
    const initialTheme = getInitialTheme();
    document.documentElement.setAttribute('data-theme', initialTheme);
    changePrimeReactTheme(initialTheme);
  }, []);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

    const handleChange = (e) => {
      if (!localStorage.getItem('app-theme')) {
        const newSystemTheme = e.matches ? 'dark' : 'light';
        setTheme(newSystemTheme);
        document.documentElement.setAttribute('data-theme', newSystemTheme);
        changePrimeReactTheme(newSystemTheme);
      }
    };

    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return <ThemeContext.Provider value={{ theme, toggleTheme }}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);
